import React from "react";
import { Box, FormHelperText, useTheme } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";
import { ProposalDetailsFormFields } from "@/modules/property-tracks/hooks/rental-financial-proposal/multi-step-form.hook";
import NwChip from "@/modules/common/components/ui-kit/chip";

interface Props {
  options: string[];
  form: UseFormReturn<ProposalDetailsFormFields>;
}

const ProposalInformationChips: React.FC<Props> = ({ options, form }) => {
  const handleChange = (value: string[] | undefined, option: string) => {
    if (!value) return [option];
    let newValue: string[];
    if (value?.includes(option)) {
      newValue = value.filter((i) => i !== option);
    } else {
      newValue = [...value, option];
    }
    return newValue;
  };

  const theme = useTheme();
  return (
    <Controller
      name="proposalInformation"
      control={form.control}
      // defaultValue={[]}
      render={({ field, fieldState }) => (
        <Box>
          {!!fieldState.error && (
            <FormHelperText error>{fieldState.error?.message}</FormHelperText>
          )}
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
            {options.map((option) => (
              <NwChip
                key={option}
                label={option}
                color={field.value?.includes(option) ? "primary" : "default"}
                variant={"outlined"}
                sx={{
                  borderRadius: theme.nawy.radius.lg,
                }}
                onClick={() =>
                  field.onChange(handleChange(field.value, option))
                }
                clickable
              />
            ))}
          </Box>
        </Box>
      )}
    />
  );
};

export default ProposalInformationChips;
